import React, { useEffect, useState } from "react";
import "./About.css";
import "./About.css";
import rightIm from "./../images/waralogo.png";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Media from "./Media";
function About() {
  const [contactInfo, setContactInfo] = useState([]);
  const navigate = useNavigate();
  console.log(contactInfo);
  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/contact/getcontact")
      .then((res) => {
        setContactInfo(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ y: 10, opacity: 1 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -10, opacity: 1 }}
        transition={{ duration: 0.7 }}
        id="about"
        className="section about-section  md:pb-16 pt-24 px-[2%]"
      >
        <div className="container block h-full md text-xl mt-4">
          <motion.div
            initial={{ y: -10, opacity: 1 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 10, opacity: 1 }}
            transition={{ duration: 0.7 }}
            className="flex justify-center mb-8"
          >
            <div className="col col-md-6 col-md-push-3">
              <div className="text-center">
                <em className="text-gray-500">Who we are</em>
                <h2 className="text-4xl md:text-6xl lg:text-8xl  font-bold font-play">
                  About Us
                </h2>
              </div>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3   gap-4 ">
            <motion.div
              initial={{ opacity: 1, translateX: "-100%" }}
              whileInView={{ opacity: 1, translateX: 0 }}
              exit="exit"
              transition={{ duration: 0.8 }}
              className="-p-12 -mt-5"
            >
              <div className="relative w-full">
                {/* Background Image */}
                <img className="w-full" src={rightIm} alt="Background" />

                {/* SVG Overlay */}
                <svg
                  className="absolute top-10 left-0 w-full h-full"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 463 478"
                >
                  <clipPath id="svgPath">
                    <path
                      className="shape-01"
                      d="M446.453,315.122V162.8a81.583,81.583,0,0,0-41.008-70.71L272.936,15.927a82.323,82.323,0,0,0-82.014,0L58.413,92.088A81.582,81.582,0,0,0,17.4,162.8V315.122a81.582,81.582,0,0,0,41.008,70.709l132.509,76.162a82.337,82.337,0,0,0,82.014,0l132.509-76.162A81.582,81.582,0,0,0,446.453,315.122Z"
                    ></path>
                  </clipPath>

                  <path
                    id="Profile_pic_border"
                    data-name="Profile pic border"
                    className="shape-02"
                    d="M420.44,385.875l-134.269,76.17a84.339,84.339,0,0,1-54.674,9.913,84.337,84.337,0,0,1-54.673-9.913L42.555,385.875A81.406,81.406,0,0,1,1,315.157V162.815A81.409,81.409,0,0,1,42.555,92.1l134.269-76.17A84.333,84.333,0,0,1,231.5,6.014a84.336,84.336,0,0,1,54.674,9.913L420.44,92.1a81.412,81.412,0,0,1,41.553,70.718V315.157A81.409,81.409,0,0,1,420.44,385.875Zm26.013-70.753V162.8a81.583,81.583,0,0,0-41.008-70.71L272.936,15.927a82.323,82.323,0,0,0-82.014,0L58.413,92.088A81.582,81.582,0,0,0,17.4,162.8V315.122a81.582,81.582,0,0,0,41.008,70.709l132.509,76.162a82.337,82.337,0,0,0,82.014,0l132.509-76.162A81.582,81.582,0,0,0,446.453,315.122Z"
                  ></path>
                </svg>
              </div>
            </motion.div>
            <motion.div
             initial={{ opacity: 1, translateY: "30%" }}
              whileInView={{ opacity: 1, translateY: 0 }}
              exit="exit"
              transition={{ duration: 1,delay:0.3 }}
              className="mt-12 md:mt-0"
            >
              <div className="text-gray-500 text-base md:text-lg">
                <p className="mb-12">
                  Wara Technology is a cutting-edge software company that
                  specialized in transforming ideas into powerful digital
                  solutions. Our mission is to empower businesses by delivering
                  innovative, scalable, and user-friendly technology that drives
                  growth and enhances efficiency. Let us help you transform your
                  ideas into impactful digital products!
                </p>
                <p>
                  Our pledge to you is transparency, integrity, and relentless
                  effort. We are always at your service, ready to address your
                  queries and offer the most effective solutions tailored to
                  your needs.
                </p>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 1, translateX: "100%" }}
              whileInView={{ opacity: 1, translateX: 0 }}
              exit="exit"
              transition={{ duration: 0.8,delay:0.2 }}
            >
              {contactInfo[0] ? (
                <ul className="md:mb-40 gap-y-8 text-base md:text-lg lg:text-xl">
                  <li className="mb-8">
                    <strong>Direct number:</strong>
                    <Link
                      to={`tell://${contactInfo[0].phone}`}
                      className="text-gray-500"
                      target="_blank"
                    >
                      {contactInfo[0].phone}
                    </Link>
                  </li>
                  <li className="mb-8">
                    <strong>Email:</strong>
                    <Link
                      to={`https://mail.google.com/mail/?view=cm&fs=1&to=${contactInfo[0].email}`}
                      className="text-gray-500"
                      target="_blank"
                    >
                      {contactInfo[0].email}
                    </Link>
                  </li>
                  <li className="mb-8">
                    <strong>Address:</strong>
                    <span className="text-gray-500">
                      {contactInfo[0].address}
                    </span>
                  </li>
                  <li className="mb-8">
                    <strong>WhatsApp number:</strong>
                    <span className="text-gray-500">
                      {contactInfo[0].phone}
                    </span>
                  </li>
                  {/* <li className="">
                    <strong>Telegram contact:</strong>{" "}
                    {contactInfo[0].telegram_contact}
                  </li> */}
                </ul>
              ) : null}
            </motion.div>
          </div>
        </div>
        {/* <Media /> */}
      </motion.div>
    </AnimatePresence>
  );
}

export default About;
